// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PushpinFilledSvg from "@fishx/icons-svg/es/asn/PushpinFilled";
import FishxIcon from '../components/FishxIcon';

var PushpinFilled = function PushpinFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PushpinFilledSvg
  }));
};

PushpinFilled.displayName = 'PushpinFilled';
export default React.forwardRef(PushpinFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PushpinFilled.js
// module id = 3938
// module chunks = 0